import * as _ from 'lodash';
import { environment } from './environments/environment';

const prod = environment.production;

export class ServerEnvUrl {

  constructor() { }

  public static get API_URL(): string {

    const url = prod ?
      (environment.endpoints.api) :
      (window.location.protocol + '//' + window.location.hostname + ':3000');

    // console.log(prod, url);
    
    return url;
  }

  public static get APP_URL(): string {
    return environment.endpoints.app;
  }

  public static get SOCKET_URL(): string {
    return environment.endpoints.socket;
  }

  public static get WEBAPP_URL(): string {
    return environment.endpoints.webapp;
  }
}
